import React, {Component} from 'react';
import {connect} from 'react-redux';
import MerchantAction from '../../actions/MerchantAction';
import Preloader from '../Preloader';
import moment from "moment/moment";
class Profile extends Component {

  componentDidMount() {
    this.props.getProfile();
  }
  getWeekName(index) {
    let weekNames = [
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
      'Sunday'
    ];
    return weekNames[index];
  }
  template(merchant) {
    const merchantOpenHours = merchant.opening_hours_raw ? merchant.opening_hours_raw : [];
    if (merchant.merchant_types != null) {
      var typesNamesArray = merchant.merchant_types.map(function(item) {
        return item['name'];
      });
      var typesNames = typesNamesArray.join(", ")
    }
    return (
      <div>
        <div className="row" style={{margin: '0px 15px'}}>
          <div className="col-md-12">
            <div className="panel panel-default">
              <div className="panel-heading">
                <h3 className="panel-title">Merchant details</h3>
              </div>
              <div className="panel-control">
                <a href="/#/merchant_info/edit" className="btn btn-action">
                  Edit merchant
                </a>
              </div>
              <div className="panel-body">
                <table className="table table-condensed table-responsive profile">
                  <tbody>
                  <tr>
                    <td>
                      <div className="form-group">
                        <label className="col-sm-2 control-label bold">Name</label>
                        <div className="col-sm-10">
                          {merchant.name}
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="form-group">
                        <label className="col-sm-2 control-label bold">Phone number</label>
                        <div className="col-sm-10">
                          {merchant.display_phone}
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="form-group">
                        <label className="col-sm-2 control-label bold">Contact email</label>
                        <div className="col-sm-10">
                          {merchant.contact_email}
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="form-group">
                        <label className="col-sm-2 control-label bold">Description</label>
                        <div className="col-sm-10">
                          {merchant.description}
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="form-group">
                        <label className="col-sm-2 control-label bold">Website</label>
                        <div className="col-sm-10">
                          {merchant.website}
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="form-group">
                        <label className="col-sm-2 control-label bold">Logo</label>
                        <div className="col-sm-10">
                          <img src={merchant.logo_url} height="100" alt="Logo"/>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="form-group">
                        <label className="col-sm-2 control-label bold">Background</label>
                        <div className="col-sm-10">
                          <img src={merchant.background_url} height="120" alt="Background"/>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="form-group">
                        <label className="col-sm-2 control-label bold">Public Profile</label>
                        <div className="col-sm-10">
                          {merchant.visible_to_customers ? 'Yes' : 'No'}
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="form-group">
                        <label className="col-sm-2 control-label bold">Merchant Types</label>
                        <div className="col-sm-10">
                          <div className="col-sm-10">
                            {typesNames}
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="panel panel-default" style={{marginTop: '15px'}}>
              <div className="panel-heading">
                <h3 className="panel-title">Adress</h3>
              </div>
              <div className="panel-body">
                <table className="table table-condensed">
                  <tbody>
                  <tr>
                    <td>
                      <div className="form-group">
                        <label className="col-sm-2 control-label bold">Address 1</label>
                        <div className="col-sm-10">
                          {merchant.address ? merchant.address.line1 : ''}
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="form-group">
                        <label className="col-sm-2 control-label bold">Address 2</label>
                        <div className="col-sm-10">
                          {merchant.address ? merchant.address.line2 : ''}
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="form-group">
                        <label className="col-sm-2 control-label bold">City</label>
                        <div className="col-sm-10">
                          {merchant.address ? merchant.address.city : ''}
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="form-group">
                        <label className="col-sm-2 control-label bold">State</label>
                        <div className="col-sm-10">
                          {merchant.address ? merchant.address.state : ''}
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="form-group">
                        <label className="col-sm-2 control-label bold">Zip</label>
                        <div className="col-sm-10">
                          {merchant.address ? merchant.address.zip : ''}
                        </div>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="panel panel-default" style={{marginTop: '15px'}}>
              <div className="panel-heading">
                <h3 className="panel-title">Location</h3>
              </div>
              <div className="panel-body">
                <table className="table table-condensed">
                  <tbody>
                  <tr>
                    <td>
                      <div className="form-group">
                        <label className="col-sm-2 control-label bold">Latitude</label>
                        <div className="col-sm-10">
                          {merchant.latitude}
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="form-group">
                        <label className="col-sm-2 control-label bold">Longitude</label>
                        <div className="col-sm-10">
                          {merchant.longitude}
                        </div>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="panel panel-default" style={{marginTop: '15px'}}>
              <div className="panel-heading">
                <h3 className="panel-title">Open hours</h3>
              </div>
              <div className="panel-body">
                <table className="table table-condensed">
                  <tbody>
                  {merchantOpenHours.sort((a, b) => a.open_day > b.open_day).map((item, key) => {
                    let open_time = item.open_time.toString().length === 3 ? item.open_time.toString().substr(0,1) :  item.open_time.toString().substr(0,2);
                    let close_time = item.close_time.toString().length === 3 ? item.close_time.toString().substr(0,1) :  item.close_time.toString().substr(0,2);
                    let openTime = parseInt(open_time) > 12 ? parseInt(item.open_time.toString().substr(0,2)) - 12 : open_time;
                    let closeTime = parseInt(close_time) > 12 ? parseInt(item.close_time.toString().substr(0,2)) - 12 : close_time;
                    let openTimePrefix = parseInt(open_time) > 12 ? ' pm' : ' am';
                    let closeTimePrefix = parseInt(close_time) > 12 ? ' pm' : ' am';
                    return <tr key={key}>
                              <td>
                                <div className="form-group">
                                  <label className="col-sm-2 control-label bold">{this.getWeekName(item.open_day)}:</label>
                                  <div className="col-sm-10">

                                    {!item.closed ? openTime + ':' + item.open_time.toString().substr(item.open_time.toString().length - 2,item.open_time.toString().length)  + openTimePrefix +
                                    ' - ' + closeTime + ':' + item.close_time.toString().substr(item.close_time.toString().length - 2,item.close_time.toString().length) + closeTimePrefix : 'Closed'}
                                    {!item.closed && item.open_day !== item.close_day ? <span className="ml10"><span className="red">*</span> closes next day</span> : null}
                                  </div>
                                </div>
                              </td>
                          </tr>
                  })}
                  {merchantOpenHours.length === 0 ?
                    <tr>
                      <td className="text-left">
                        You don't set open hours.
                      </td>
                    </tr>
                    :null}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  render() {
    const merchant = this.props.merchant;
    if (merchant && !this.props.isBusy) {
      return this.template(merchant);
    } else {
      return <Preloader />
    }
  }
}

export default connect(
  state => ({
    merchant: state.merchant,
    isBusy: state.requestStatus
  }),
  dispatch => ({
    getProfile: () => {
      dispatch(MerchantAction.get());
    }
  })
)(Profile);



/** WEBPACK FOOTER **
 ** ./src/components/MerchantInfo/index.js
 **/